import { useCallback, useState } from 'react';
import { loadDrawerMode, saveDrawerMode } from './persistence.js';

export const DRAWER_MODES = ['compact', 'wide', 'fullscreen'];

const nextMode = (mode) => {
  if (mode === 'fullscreen') return 'wide';
  if (mode === 'compact') return 'wide';
  return 'fullscreen';
};

export const useDrawerMode = () => {
  const [drawerMode, setDrawerModeState] = useState(() => loadDrawerMode());
  const setDrawerMode = useCallback((mode) => {
    const next = DRAWER_MODES.includes(mode) ? mode : 'wide';
    setDrawerModeState(next);
    saveDrawerMode(next);
  }, []);
  const toggleFullscreen = useCallback(() => {
    setDrawerModeState((current) => {
      const next = nextMode(current);
      saveDrawerMode(next);
      return next;
    });
  }, []);
  return { drawerMode, setDrawerMode, toggleFullscreen };
};
